import { Trans } from '@lingui/react/macro';

import { useUniversalToFDI } from '@/utils/internationalization/useUniversalToFDI';
import type { ValidUniversalToothId } from '@videa/utils';

import { getQuadrantByToothNumber } from './helpers';

interface Props {
  isActiveImage: boolean;
  selectedTeeth: string[];
}

export const AISummaryLabel = ({ isActiveImage, selectedTeeth }: Props) => {
  const { displayToothNumber, displayLocalizedQuadrantShortName } =
    useUniversalToFDI();
  const selectedToothQuadrant = getQuadrantByToothNumber(
    selectedTeeth[0] as ValidUniversalToothId,
  );

  // In the case when we have selected an image from tooth selection, we don't
  // want to show the tooth label.
  const showToothDetails = !!selectedTeeth.length && !isActiveImage;

  return (
    <p className="vai-typography-small vai-text-[#FAFAFA]">
      <Trans>AI Summary</Trans>
      {showToothDetails && (
        <>
          {' - '}
          <Trans>Tooth </Trans>
          {displayToothNumber(selectedTeeth[0])}
          {selectedToothQuadrant &&
            `, ${displayLocalizedQuadrantShortName(selectedToothQuadrant)}`}
        </>
      )}
    </p>
  );
};
